import type { IListResponse, ISubjectPersons } from '@dakedake/types'
import { request } from '@umijs/max'

/** 获取关联详情 GET /backend/subjectPersons/:id */
export async function subjectPersonsDetail(options?: Record<string, any>) {
  return request<{ data: ISubjectPersons }>('/backend/subjectPersons/:id', {
    method: 'GET',
    ...options
  })
}

/** 获取关联人物列表 GET /backend/subjectPersons/list */
export async function subjectPersonsList(
  params: {
    // query
    /** 当前的页码 */
    current?: number
    /** 页面的容量 */
    pageSize?: number
    sid?: number
    aid?: number
    order?: 'ASC' | 'DESC'
  },
  options?: Record<string, any>
) {
  return request<IListResponse<ISubjectPersons>>('/backend/subjectPersons/list', {
    method: 'GET',
    params,
    ...options
  })
}

/** 添加/编辑关联人物 POST /api/subjectPersons/add */
export async function subjectPersonsAdd(body: ISubjectPersons) {
  return request<{ data: ISubjectPersons, status: number, message: string }>('/backend/subjectPersons/add', {
    method: 'POST',
    data: body
  })
}

/** 删除关联人物 DELETE /api/subjectPersons/delete */
export async function subjectPersonsDelete(body: { id?: number }) {
  return request<{ data: number }>('/backend/subjectPersons/delete', {
    method: 'DELETE',
    data: body
  })
}

/** 清理重复关联人物 POST /backend/subjectPersons/cleanDuplicates */
export async function subjectPersonsCleanDuplicates(options?: Record<string, any>) {
  return request<{ data: { deletedCount: number, totalDuplicates: number }, success: boolean, message: string }>('/backend/subjectPersons/cleanDuplicates', {
    method: 'POST',
    ...options
  })
}

/** 同步关联人物 POST /backend/subjectPersons/sync */
export async function subjectPersonsSync(body: { sid: number, persons: Array<{ pid: number, position: string }> }) {
  return request<{ data: { deletedCount: number, addedCount: number, updatedCount: number }, success: boolean, message: string }>('/backend/subjectPersons/sync', {
    method: 'POST',
    data: body
  })
}
